import { render, staticRenderFns } from "./edit-screenshot.vue?vue&type=template&id=52aa6080&scoped=true"
import script from "./edit-screenshot.vue?vue&type=script&lang=js"
export * from "./edit-screenshot.vue?vue&type=script&lang=js"
import style0 from "./edit-screenshot.vue?vue&type=style&index=0&id=52aa6080&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aa6080",
  null
  
)

export default component.exports